import axios from "axios";
import { apiEndpoint } from "../../../routes/api_endpoints";
import { API_KEY } from "../../../utilities/apiKey";
/**
 * @typedef {Object} Wallet
 * @property {string} WalletID
 * @property {string} WalletName
 */
/**
 *
 * @param {string} MobileNumber
 * @returns {Promise<Wallet[]>}
 */
const getWallets = (MobileNumber = "") =>
  new Promise((resolve, reject) => {
    axios
      .post(
        apiEndpoint,
        {
          RequestID: "RUNNINGMOVIES",
          SessionID: "HBhGpLw0efgwbDqILlYSCC9WT5hoo=4oCh",
          Country: "KENYA",
          City: "NAIROBI",
          UserID: "Pesapal",
          Key: "2344",
          MobileNumber,
          TrxReference: "123487",
          IMEI: "231766434532535",
        },
        {
          headers: {
            "X-API-KEY": API_KEY,
          },
        }
      )
      .then((response) => {
        let data = response.data[0];
        if (data && data.Wallet && data.Wallet.length > 0) {
          resolve(data.Wallet);
        } else {
          reject(new Error("Wallets not found"));
        }
      })
      .catch(reject);
  });
export default getWallets;
